/*
 * Swatch lightbox — click a fabric swatch to see it full size.
 *
 * Added 2026-08-06. The Fabric Swatches page already shipped the overlay
 * markup (#swatchOverlay / #swatchBig / #swatchLabel) and its CSS inside the
 * page content, but the JavaScript that opens it was never written, so
 * clicking a swatch did nothing. This wires it up.
 *
 * The Wood Swatches page uses the theme's swatches-lightbox section with
 * lightbox-plus-jquery and already worked, so it is untouched.
 */
(function swatchLightbox() {
  var thumbs = document.querySelectorAll(".swatch-thumb");
  if (!thumbs.length) return;

  var overlay = document.getElementById("swatchOverlay");

  // Build the overlay if a page uses .swatch-thumb without shipping one.
  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "swatch-overlay";
    overlay.id = "swatchOverlay";
    overlay.innerHTML =
      '<img id="swatchBig" alt=""><div class="swatch-label" id="swatchLabel"></div>';
    document.body.appendChild(overlay);

    if (!document.getElementById("swatchLightboxStyles")) {
      var css = document.createElement("style");
      css.id = "swatchLightboxStyles";
      css.textContent =
        ".swatch-overlay{display:none;position:fixed;top:0;left:0;right:0;bottom:0;" +
        "background:rgba(0,0,0,0.85);z-index:99999;justify-content:center;" +
        "align-items:center;cursor:pointer}" +
        ".swatch-overlay img{max-width:90vw;max-height:90vh;border-radius:8px;" +
        "box-shadow:0 0 40px rgba(0,0,0,0.5)}" +
        ".swatch-overlay .swatch-label{position:absolute;bottom:5%;left:50%;" +
        "transform:translateX(-50%);color:#fff;font-size:18px;" +
        "background:rgba(0,0,0,0.6);padding:8px 20px;border-radius:4px}" +
        ".swatch-thumb{cursor:pointer}";
      document.head.appendChild(css);
    }
  }

  var big = overlay.querySelector("#swatchBig");
  var label = overlay.querySelector("#swatchLabel");
  if (!big) return;

  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-hidden", "true");

  var lastFocused = null;

  // Strip Shopify's _300x / _152x152 size suffix so we open the original file.
  function fullSize(src) {
    return src.replace(/_(\d+)?x(\d+)?(_crop_[a-z]+)?(?=\.(jpe?g|png|gif|webp))/i, "");
  }

  function openSwatch(img) {
    lastFocused = img;
    big.src = fullSize(img.currentSrc || img.src);
    big.alt = img.alt || "";
    if (label) {
      label.textContent = img.alt || "";
      label.style.display = img.alt ? "" : "none";
    }
    overlay.style.display = "flex";
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeSwatch() {
    overlay.style.display = "none";
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    big.removeAttribute("src");
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  Array.prototype.forEach.call(thumbs, function (img) {
    img.setAttribute("tabindex", "0");
    img.setAttribute("role", "button");
    if (img.alt) img.setAttribute("aria-label", "View " + img.alt + " larger");

    img.addEventListener("click", function () {
      openSwatch(img);
    });

    img.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        openSwatch(img);
      }
    });
  });

  overlay.addEventListener("click", closeSwatch);

  document.addEventListener("keydown", function (e) {
    if ((e.key === "Escape" || e.key === "Esc") && overlay.style.display === "flex") {
      closeSwatch();
    }
  });
})();
